import { Box } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
  border?: boolean
}
const TableRowMobile = ({ children, border }: Props) => {
  return (
    <Box
      sx={{
        borderBottom: border ? '1px solid #D4D4D4' : '0px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        paddingY: '20px',
      }}
    >
      {children}
    </Box>
  )
}

export default TableRowMobile
